import { clearSessionEndSignal } from '@/utils/session'

export default {
  SET_USER_TOKEN(state, { token }) {
    // Every path that hands us a token — login, MFA, register, password reset, a
    // refresh — passes through here, which makes it the one place that knows a
    // session is alive again.
    clearSessionEndSignal()
    state.token = token
    localStorage.setItem('token', token)
  },
  SET_USER_REFRESH_TOKEN(state, { refreshToken }) {
    state.refreshToken = refreshToken
    localStorage.setItem('refreshToken', refreshToken)
  },
  SET_USER_ID(state, { id }) {
    state.id = id
    localStorage.setItem('id', id)
  },
  REMOVE_USER_TOKEN(state) {
    state.token = null
    localStorage.removeItem('token')
  },
  REMOVE_USER_REFRESH_TOKEN(state) {
    state.refreshToken = null
    localStorage.removeItem('refreshToken')
  },
  REMOVE_USER_ID(state) {
    state.id = null
    localStorage.removeItem('id')
  },
  REMOVE_USER_API_KEY_DATA(state) {
    state.userApiKeyData = {}
  },
  SET_USER_DATA(state, data) {
    state.userData = {...data}
    localStorage.setItem('currentFiatKey', data?.preferredCurrency || state.fiatList[0].key)
  },
  SET_USER_API_KEY_DATA(state, data) {
    state.userApiKeyData = { ...data }
  },
  SET_REQUESTS_ATTENTION_MODAL(state, value) {
    state.requestsAttentionModal = value
  },
}
